import { DomainSchema } from '@multitec/domain'
import { useQuery } from 'react-query'
import { z } from 'zod'

import { Base } from '../base'
import { MyURLSearchParams } from '../utils/url-search-params'

const BASE_URL = '/entity/order-items'

class UpdateList extends Base {
  private body = z.object({
    order_id: z.number(),
    order_report_id: z.number().nullable().optional(),
    items: z.array(
      z.object({
        item: z.object({
          type: z.enum(['PRODUTO', 'SERVICO', 'EQUIPAMENTO']),
          name: z.string(),
          manufacturer: z.string().nullable().optional(),
          product_id: z.string().nullable().optional(),
          product_sku: z.string().nullable().optional(),
          equipment_id: z.string().nullable().optional(),
          equipment_serial: z.string().nullable().optional(),
          buy_price: z.number(),
          sell_price: z.number(),
        }),
        quantity: z.coerce.number(),
      }),
    ),
  })

  private response = z.object({ count: z.number() })

  handle = async (body: z.infer<typeof this.body>) => {
    const { data } = await this.axios.post(`${BASE_URL}/list`, body)
    return this.response.parse(data.result)
  }
}

// class Update extends Base {
//   private body = DomainSchema.Storage.pick({
//     name: true,
//     description: true,
//     active: true,
//   })

//   private response = DomainSchema.Storage

//   handle = async (id: string, body: z.infer<typeof this.body>) => {
//     const { data } = await this.axios.put(`${BASE_URL}/${id}`, body)
//     return this.response.parse(data.result)
//   }
// }

class Search extends Base {
  private searchParams = z.object({
    order_id: z.number(),
    order_report_id: z.number().optional(),
  })

  private response = z.array(
    z.object({
      ...DomainSchema.OrderItem.shape,
      Product: DomainSchema.Product.nullable(),
      Equipment: DomainSchema.Equipment.nullable(),
    }),
  )

  handle = (searchParams: z.infer<typeof this.searchParams>) => {
    return useQuery(['order-item', 'search', { ...searchParams }], async () => {
      const queryParams = new MyURLSearchParams(searchParams).toString()
      const { data } = await this.axios.get(BASE_URL + `?${queryParams}`)

      return this.response.parse(data.result)
    })
  }
}

// class LoadOne extends Base {
//   private response = DomainSchema.Storage

//   handle = (id: string) => {
//     return useQuery(['storage', 'load-one', { id }], async () => {
//       const { data } = await this.axios.get(`${BASE_URL}/${id}`)
//       return this.response.parse(data.result)
//     })
//   }
// }

export default class extends Base {
  // Create = new Create(this.axios).handle
  // Update = new Update(this.axios).handle
  Search = new Search(this.axios).handle
  UpdateList = new UpdateList(this.axios).handle
}
